import { AddEditAdmin, AddEditUserProfile, DeleteAdminById, GetadminById, GetAllAdminRoles, GetAllAdminsByCompanyId, GetAllUserLog, GetUserProfile } from "../ApiEndPoints.js";
import { axiosGetWithencryption, axiosPostWithencryption } from "../AxiosRequests.js";

export default class UtilityServices {

    // User profile
    async getUserProfile(request) {
        return axiosGetWithencryption(GetUserProfile, request);
    }

    async addEditUserProfile(request) {
        return axiosPostWithencryption(AddEditUserProfile, request);
    }

    // Admin role
    async getAllAdminRoles(request) {
        return axiosGetWithencryption(GetAllAdminRoles, request);
    }
    async getAllAdminsByCompanyId(request) {
        return axiosGetWithencryption(GetAllAdminsByCompanyId, request);
    }
    async getadminById(request) {
        return axiosGetWithencryption(GetadminById, request);
    }
    async addEditAdmin(request) {
        return axiosPostWithencryption(AddEditAdmin, request);
    }
    async deleteAdminById(request) {
        return axiosGetWithencryption(DeleteAdminById, request);
    }
    async getAllUserLog(request) {
        return axiosPostWithencryption(GetAllUserLog, request);
    }
}
